import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPandoraComponent } from './simple-icons-pandora.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPandoraComponent ],
    exports:      [ SimpleIconsPandoraComponent ],
    bootstrap:    []
})
export class SimpleIconsPandoraModule {}
